export default "__VITE_ASSET__CZe5e7$l__"